import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  GET_PREQUALIFIED_JSON_URL,
  SEO_JSON_URL,
} from '../../assets/constants';
import { RuntimeConfigService } from './runtime-config';

@Injectable({
  providedIn: 'root',
})
export class AWSService {
  private isEmptyObject = (obj: any) => Object.keys(obj).length === 0;
  hostname = '';
  s3BucketUrl = ''; //default
  private prequalifiedJSONData = new BehaviorSubject<any>(null);
  prequalifiedJSONData$ = this.prequalifiedJSONData.asObservable();

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) platformId: NonNullable<unknown>,
    private runtimeConfigService: RuntimeConfigService
  ) {
    if (isPlatformBrowser(platformId)) {
      this.hostname = window.location.hostname;
      this.s3BucketUrl =
        (this.runtimeConfigService.prequalConfig
          ?.APP_JSON_S3_BUCKET_URL as unknown as string) || '';
    }
  }

  getPrequalifiedData(): Observable<void> {
    return this.getS3Object(GET_PREQUALIFIED_JSON_URL).pipe(
      map((prequalifiedJson) => {
        if (this.isEmptyObject(prequalifiedJson)) {
          throw new Error('Retrieved prequalified data is empty');
        }
        this.prequalifiedJSONData.next(prequalifiedJson);
      })
    );
  }

  getSEOData(): Observable<any> {
    return this.getS3Object(SEO_JSON_URL).pipe(
      map((seoJson) => {
        if (this.isEmptyObject(seoJson)) {
          throw new Error('Retrieved SEO data is empty');
        }
        return seoJson;
      })
    );
  }

  private getS3Object(url: string): Observable<any> {
    return this.http
      .get(`${this.s3BucketUrl}${url}`)
      .pipe(
        map((response) =>
          JSON.parse(
            JSON.stringify(response).replace(
              /AWS_BUCKET_URL/g,
              this.s3BucketUrl
            )
          )
        )
      );
  }
}
